import * as S from '@effect/schema/Schema';
import { BadgeProgress } from '@infl-ts/ui-advocate-components';
import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
export var Badge = t.type({
  id: t.string,
  name: t.string,
  imageUrl: t.string,
  description: t.string,
  level: nullable(t.type({
    id: t.string,
    rank: t.number
  }))
});
export var BadgeProgression = t.type({
  badge: Badge,
  badgeProgress: nullable(BadgeProgress),
  earnedDate: nullable(t.string)
});
var Level = t.type({
  id: t.string,
  name: t.string
});
var NextLevelProgress = t.type({
  level: t.intersection([Level, t.type({
    rank: t.number
  })]),
  earnedBadgesCount: t.number,
  requiredBadgesCount: t.number
});
var Profile = t.type({
  id: t.string,
  level: Level,
  nextLevel: nullable(NextLevelProgress)
});
export var ProfileBadgesQuery = t.type({
  profile: Profile,
  badgeProgressions: t.array(BadgeProgression)
});
export var AchievementsBlockConfig = S.struct({
  typename: S.literal('AchievementsBlock'),
  id: S.string,
  hash: S.string
});